import { useAccessFeatures } from "@/auth/access-features";
import { FEATURE_CATALOG } from "@/auth/feature-catalog";

// Whether the viewer's roles show a game kind: the games as a whole and that kind, both. The routes of Grow > Play
// require grow and grow.play on top, so a caller outside them checks those as well.
export function useGameAccess(): (kindFeatureKey: string) => boolean {
  const { hasFeature } = useAccessFeatures();
  return (kindFeatureKey) => hasFeature(FEATURE_CATALOG.growPlayGames.key) && hasFeature(kindFeatureKey);
}
